import {
  Frame,
  isNodeOrVoidNode,
  NodeOrVoidNode,
  voidNode,
} from '@wandb/weave/core';

import {PanelInput} from './panel';

export type ChildPanelConfig =
  | undefined
  | ChildPanelFullConfig
  | NodeOrVoidNode;

export interface ChildPanelFullConfig<C = any> {
  vars: Frame;
  input_node: NodeOrVoidNode;
  id: string;
  config: C;
}

export interface ChildPanelProps {
  editable?: boolean;
  controlBar?: 'off' | 'editable' | 'titleBar';
  passthroughUpdate?: boolean;
  pathEl?: string;
  prefixButtons?: JSX.Element;
  allowedPanels?: string[];
  overflowVisible?: boolean;
  config: ChildPanelConfig | undefined;
  updateConfig: (newConfig: ChildPanelFullConfig) => void;
  updateConfig2?: (change: (oldConfig: any) => any) => void;
  updateInput?: (partialInput: PanelInput) => void;
  updateName?: (newName: string) => void;
}

export const CHILD_PANEL_DEFAULT_CONFIG: ChildPanelFullConfig = {
  vars: {},
  input_node: voidNode(),
  id: '',
  config: undefined,
};

export const getFullChildPanel = (
  item: ChildPanelConfig
): ChildPanelFullConfig => {
  if (item == null) {
    return CHILD_PANEL_DEFAULT_CONFIG;
  } else if (isNodeOrVoidNode(item)) {
    return {...CHILD_PANEL_DEFAULT_CONFIG, input_node: item};
  } else {
    return item;
  }
};
